import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Collapse Control Icon
 *
 * @file CollapseControl.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const CollapseControl = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.4138 8.99769H18.9925C19.5445
        8.99769 19.992 9.44518 19.992 9.99719C19.992
        10.5492 19.5445 10.9967 18.9925 10.9967H13.995C13.443
        10.9967 12.9955 10.5492 12.9955 9.99719V4.99968C12.9955
        4.44767 13.443 4.00018 13.995 4.00018C14.547 4.00018
        14.9945 4.44767 14.9945 4.99968V7.5684L18.2829 4.29004C18.6748
        3.89811 19.3102 3.89811 19.7021 4.29004C20.0941 4.68196 20.0941
        5.3174 19.7021 5.70933L16.4138 8.99769ZM5.00139
        12.9957H9.99889C10.5509 12.9957 10.9984 13.4432 10.9984
        13.9952V18.9927C10.9984 19.5448 10.5509 19.9922 9.99889
        19.9922C9.44688 19.9922 8.99939 19.5448 8.99939 18.9927V16.414L5.71103
        19.7024L5.70524 19.7082C5.31331 20.0969 4.68047 20.0943 4.29174
        19.7024L4.28595 19.6966C3.89722 19.3047 3.89982 18.6718 4.29174
        18.2831L7.57011 14.9947H5.00139C4.44938 14.9947 4.00189 14.5473
        4.00189 13.9952C4.00189 13.4432 4.44938 12.9957 5.00139 12.9957Z"
      fill="currentcolor"
    />
  </SvgIcon>
);

export default CollapseControl;
